import { render } from "./sys-model.vue?vue&type=template&id=1ad2797c&scoped=true"
import script from "./sys-model.vue?vue&type=script&lang=js"
export * from "./sys-model.vue?vue&type=script&lang=js"

import "./sys-model.vue?vue&type=style&index=0&id=1ad2797c&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad2797c"]])

export default __exports__